import { ClassDetailsNoSectionsQuery } from "@outschool/gql-frontend-generated";
import { gql } from "@outschool/ui-apollo";
import { validate as isUuid } from "uuid";

import { ActivityListingFragment, ListingCardFragment } from "./fragments";

export default gql`
  query OtherListingsByTeacher(
    $activityUid: ID!
    $skipRating: Boolean!
    $withRecentReviews: Boolean!
  ) {
    listing(activityUid: $activityUid) {
      similarListings {
        sameTeacher {
          ...ListingCard_listing
        }
      }
    }
  }
  ${ListingCardFragment}
`;

export const OtherListingsByTeacherQueryMobile = gql`
  query OtherListingsByTeacherMobile($activityUid: ID!, $skipRating: Boolean!) {
    listing(activityUid: $activityUid) {
      similarListings {
        sameTeacher {
          ...ActivityListing_listing
        }
      }
    }
  }
  ${ActivityListingFragment}
`;

export const OtherListingsByTeacherVariable = (
  activity:
    | ClassDetailsNoSectionsQuery["activity"]
    | { uid?: string; upsell_activity_uid?: string | null }
) => {
  return !activity?.uid || !isUuid(activity.uid)
    ? { skip: true }
    : {
        variables: {
          activityUid: activity?.uid,
          skipRating: false,
          withRecentReviews: false,
        },
      };
};

export const OtherListingsByTeacherMobileVariable = (
  activity:
    | ClassDetailsNoSectionsQuery["activity"]
    | { uid?: string; upsell_activity_uid?: string | null }
) => {
  return !activity?.uid || !isUuid(activity.uid)
    ? { skip: true }
    : {
        variables: {
          activityUid: activity?.uid,
          skipRating: false,
        },
      };
};
